export default "__VITE_ASSET__BvW9oOJ9__"